import styled from "styled-components";
import { borders } from "@sonder/ui/source/styled/theme";

export const CommentLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-top: ${borders.standard};
  border-left: ${borders.standard};
  box-sizing: border-box;
  grid-area: commentinput;
`;

export const CommentActions = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  padding: 0 1.5rem 0.75rem;
`;
